import { ReactElement, useEffect, useState } from "react";
import { IChartWrapperProps } from "../../types";
import BarChart from "../../../../components/charts/barChart";
import { IBarChartConfig } from "../../../../components/charts/types";
import { getGenericChartConfig } from "./utils";

const BarChartWrapper = ({ cell, data, parentSize, palette, updatePalette, node, showAccumulated, schemas }: IChartWrapperProps): ReactElement => {
  const [ chartConfig, setChartConfig ] = useState<IBarChartConfig | null>(null);

  useEffect(() => {
    if (data) {
      const [ series, xAxis, yAxis ] = getGenericChartConfig(data, cell, node, palette, updatePalette, schemas);

      setChartConfig( {
        height: parentSize.height - 20,
        series,
        xAxis,
        yAxis,
        multiple: cell.groups.length > 0,
        showLegend: true,
        showValue: true,
        accumulate: true
      });
    }
  }, [ cell, data, parentSize, palette, updatePalette, node, schemas ]);

  return (
    <div className="display-grid" style={{ ...parentSize }} >
      { chartConfig && <BarChart barChartConfig={chartConfig} showAccumulated={showAccumulated}/> }
    </div>
  );
};

export default BarChartWrapper;
